'use strict';
import * as $j_com$002eraquo$002elaminar$002ekeys$002e$002dEvent$002dProcessor from "./com.raquo.laminar.keys.-Event-Processor.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1 from "./scala.scalajs.runtime.-Anon-Function1.$$-Lambda$412915ce24663401f4bc24349a746e1dbd693dc1.js";
var $p;
/** @constructor */
function $c_Lcom_raquo_laminar_keys_EventProcessor$() {
}
export { $c_Lcom_raquo_laminar_keys_EventProcessor$ as $c_Lcom_raquo_laminar_keys_EventProcessor$ };
$p = $c_Lcom_raquo_laminar_keys_EventProcessor$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lcom_raquo_laminar_keys_EventProcessor$;
/** @constructor */
function $h_Lcom_raquo_laminar_keys_EventProcessor$() {
}
export { $h_Lcom_raquo_laminar_keys_EventProcessor$ as $h_Lcom_raquo_laminar_keys_EventProcessor$ };
$h_Lcom_raquo_laminar_keys_EventProcessor$.prototype = $p;
$p.bU = (function(eventProp, shouldUseCapture, shouldBePassive) {
  return new $j_com$002eraquo$002elaminar$002ekeys$002e$002dEvent$002dProcessor.$c_Lcom_raquo_laminar_keys_EventProcessor(eventProp, shouldUseCapture, shouldBePassive, new $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1.$c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$14) => new $j_java$002elang$002e$002dObject.$c_s_Some(_$14))));
});
var $d_Lcom_raquo_laminar_keys_EventProcessor$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lcom_raquo_laminar_keys_EventProcessor$, "com.raquo.laminar.keys.EventProcessor$", ({
  ik: 1
}));
export { $d_Lcom_raquo_laminar_keys_EventProcessor$ as $d_Lcom_raquo_laminar_keys_EventProcessor$ };
var $n_Lcom_raquo_laminar_keys_EventProcessor$;
function $m_Lcom_raquo_laminar_keys_EventProcessor$() {
  if ((!$n_Lcom_raquo_laminar_keys_EventProcessor$)) {
    $n_Lcom_raquo_laminar_keys_EventProcessor$ = new $c_Lcom_raquo_laminar_keys_EventProcessor$();
  }
  return $n_Lcom_raquo_laminar_keys_EventProcessor$;
}
export { $m_Lcom_raquo_laminar_keys_EventProcessor$ as $m_Lcom_raquo_laminar_keys_EventProcessor$ };
